import styled from 'styled-components';
import { darken, rgba } from 'polished';
import { Dialog as MuiDialog } from '@material-ui/core';

const THEME_COLOR = '#6b63d5';

export const Dialog = styled(MuiDialog)`
  .MuiDialog-paper {
    border-radius: 8px;
    overflow: hidden;
  }

  .MuiDialogTitle-root {
    background: white;
    padding: 24px;
    border-bottom: 1px solid ${rgba('#000', 0.08)};

    h2 {
      font-size: 1.25rem;
      color: ${darken(0.4, THEME_COLOR)};
      font-weight: 600;
      margin: 0;
      display: flex;
      align-items: center;
      gap: 12px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .MuiDialogContent-root {
    padding: 24px;
  }

  .MuiDialogActions-root {
    padding: 16px 24px;
    border-top: 1px solid ${rgba('#000', 0.08)};
    background: ${rgba('#000', 0.02)};
  }

  .MuiButton-root {
    min-width: 32px;
    height: 32px;
    border-radius: 6px;
    text-transform: none;
    font-weight: 500;
    padding: 0 16px;

    &.MuiButton-contained {
      background: ${THEME_COLOR};
      color: white;

      &:hover {
        background: ${darken(0.1, THEME_COLOR)};
      }
    }

    &.MuiButton-outlined {
      border-color: ${rgba(THEME_COLOR, 0.2)};
      color: ${THEME_COLOR};

      &:hover {
        background: ${rgba(THEME_COLOR, 0.05)};
      }
    }
  }
`;

export const QRContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: white;
  border-radius: 8px;

  canvas {
    border-radius: 4px;
  }
`;